import React from 'react'
import styles from './categories.styles'
import injectSheet from 'react-jss'
import classNames from 'classnames'
import Category from './category/category.container'

const Categories = ({ classes, className, categories, activeCategory }) => (
  <ul className={classNames(classes.container, className)}>
    <Category category="ALL" active={activeCategory === 'ALL'} />
    {categories.map(category => (
      <Category
        key={category}
        active={activeCategory === category}
        category={category}
      />
    ))}
  </ul>
)

export default injectSheet(styles)(Categories)
